/**
 * InlineWrapper — 行内渲染块的共享包装。
 *
 * 为 inline-render 块统一输出 `<span data-toc-id="toc-render-${definitionId}">`，
 * 消除 BlockDispatcher 与 InlineGroup 中重复的包装 DOM。
 */

import type { ReactNode } from "react";

export function InlineWrapper({
    definitionId,
    children,
}: {
    definitionId: string;
    children: ReactNode;
}) {
    return <span data-toc-id={`toc-render-${definitionId}`}>{children}</span>;
}
